module.exports = __webpack_public_path__ + "static/manor-d623316c3578907bc551ecc36ceea353.png";